import React from "react";
import "../../css/termsAndConditions.css";
import Header from "./../Header/index";
import Footer from "./../Footer/Footer";
class TermsConditions extends React.Component {
  render() {
    return (
      <>
        <div className="termsAndConditionsContainer">
          {/* <Header /> */}

          <div className="container-row">
            <div className="col-sm-12 topMargin">
              <div className="TermsCenter">
                <h1 className="termsHeader">Terms of Service</h1>

                <div className="topParagraph">
                  Read our terms below to learn more about your rights and
                  responsibilities as a Fitfinity user.
                </div>
              </div>
              <img
                className="termsandConditionsImage"
                src={require("../../assests/hand.png")}
                // style={{ width: "30%" }}
              />
            </div>
          </div>
          <hr />

          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-2"></div>
              <div className="col-sm-8">
                <div className="feedback">
                  This Terms of Use agreement is effective as of
                  10-November-2019.
                </div>
                <div className="feedback">
                  Fitfinity Online Private Limited ("Fitfinity"), primarily operates,
                  controls and manages the Services (as defined below) provided
                  by it from its corporate office at #48, 29th Main , 5th
                  BlockSurvey No. 13,14 & 15, Nandini Layout, Yaswantpur,
                  Bangalore, Karnataka-560096 IN (“Bangalore Corporate Office”).
                </div>
                <div className="feedback">
                  <strong> Acceptance of Terms</strong>
                </div>
                <div className="feedback">
                  PLEASE READ THE TERMS OF USE THOROUGHLY AND CAREFULLY. The
                  terms and conditions set forth below ("Terms of Use") and the
                  Privacy Policy (as defined below) constitute a legally-binding
                  agreement between Fitfinity operating from its Bangalore
                  Corporate Office and you. These Terms of Use contain
                  provisions that define your limits, legal rights and
                  obligations with respect to your use of and participation in
                  (i) the Fitfinity website and mobile application, including the
                  classified advertisements, forums, various email functions and
                  Internet links, and all content and Fitfinity services available
                  through the domain and sub-domains of Fitfinity located at
                  www.Fitfinity.com
                </div>
                <div className="feedback">
                  The Website is owned and operated by Fitfinity Online Private
                  Limited.
                </div>
                <div className="feedback">
                  You acknowledge that the Website serves as a venue for the
                  online distribution and publication ofuser submitted
                  information between Service Professionals and Service Users,
                  and, by using, visiting, registering for, and/or otherwise
                  participating in this Website, including the Services
                  presented, promoted, and displayed on the Website, and by
                  clicking on "I have read and agree to the terms of use," you
                  hereby certify that: (1) you are either a Service Professional
                  or a prospective Service User, (2) you have the authority to
                  enter into these Terms of Use, (3) you authorize the transfer
                  of payment for Services requested through the use of the
                  Website, and (4) you agree to be bound by all terms and
                  conditions of these Terms of Use and any other documents
                  incorporated by reference herein. If you do not accept the
                  terms and conditions then please do not proceed with using
                  this website.
                </div>
                <div className="feedback">
                  <strong>
                    YOU SPECIFICALLY AGREE THAT BY USING THE WEBSITE, YOU ARE AT
                    LEAST 18 YEARS OF AGE AND YOU ARE COMPETENT UNDER LAW TO
                    ENTER INTO A LEGALLY BINDING AND ENFORCEABLE CONTRACT.
                  </strong>
                </div>
                <div className="feedback">
                  <strong> 1. PRIVACY POLICY</strong>
                </div>
                <div className="feedback">
                  Fitfinity has established a Privacy Policy that explains to users
                  how their information is collected and used. Your use of this
                  Website is governed by the Privacy Policy.
                </div>
                <div className="feedback">
                  The Privacy Policy is located at:
                  <a href="/privacy">Privacy Policy</a>
                </div>
                <div className="feedback">
                  <strong>
                    2. MODIFICATIONS TO TERMS AND CONDITIONS AND/OR PRIVACY
                    POLICY
                  </strong>
                </div>
                <div className="feedback">
                  Fitfinity reserves the right, in its sole discretion, to change,
                  modify, or otherwise amend the Terms of Use, and any other
                  documents incorporated with legal framework for other
                  legitimate business purposes, at any time, and Fitfinity will
                  post the amended Terms of Use at the domain
                  ofwww.Fitfinity.com/terms. It is your responsibility to review
                  the Terms of Use for any changes and you are encouraged to
                  check the Terms of Use frequently.
                </div>
                <div className="feedback">
                  <strong>3. LICENSE TO ACCESS</strong>
                </div>
                <div className="feedback">
                  Fitfinity hereby grants you a non-exclusive, revocable license to
                  use the Website as set forth in the Terms of Use; provided,
                  however, that (i) you will not copy, distribute, or make
                  derivative works of the Website in any medium without Fitfinity's
                  prior written consent; (ii) you will not alter or modify any
                  part of the Website other than as may be reasonably necessary
                  to use the Website for its intended purposes; and (iii) you
                  will otherwise act in accordance with the terms and conditions
                  of the Terms of Use and in accordance with all applicable
                  laws.
                </div>
                <div className="feedback">
                  <strong> 4. MEMBERSHIP ELIGIBILITY CRITERIA</strong>
                </div>
                <div className="feedback">
                  Use of the Website is available only to individuals who are at
                  least 18 years old and can form legally binding contracts
                  under applicable law. You represent, acknowledge and agree
                  that you are at least 18 years of age, and all registration
                  information that you submit is truthful and accurate. Your
                  Account (defined below) may be terminated without warning if
                  we at our discretion, believe that you are under the age of 18
                  or that you are not complying with any applicable laws, rules
                  or regulations.You need not register with Fitfinity to simply
                  visit and view the Website, but to access and participate in
                  certain features of the Website, you will need to create a
                  password-protected account ("Account"). To create an account,
                  you must submit your name, email address or mobile number
                  through the account registration page on the Website and
                  create a password. You may also register for an Account using
                  your existing Facebook account and log-in credentials (your
                  "Third-Party Site Password").You are solely responsible for
                  safeguarding your Fitfinity password at all times and shall keep
                  your Passwords secure at all times. You shall be solely
                  responsible for all activity that occurs on your Account and
                  you shall notify Fitfinity immediately of any breach of security
                  or any unauthorized use of your Account. Similarly, you shall
                  never use another's Account without Fitfinity permission. You
                  agree that you will not misrepresent yourself or represent
                  yourself as another user of the Website and/or the Services
                  offered through the Website.You hereby expressly acknowledge
                  and agree that you yourself and not Fitfinity will be liable
                  foryour losses, damages etc. (whether direct or indirect)
                  caused by an unauthorized use of your Account. Notwithstanding
                  the foregoing, you may be liable for the losses of Fitfinity or
                  others due to such unauthorized use.An Account holder is
                  sometimes referred to herein as a "Registered User."
                </div>
                <div className="feedback">
                  You acknowledge and agree that you shall comply with the
                  following policies (the "Account Policies"):
                </div>
                <div className="feedback">
                  <ul>
                    <li>
                      You shall not use any automated system, including but not
                      limited to, "robots," "spiders," "offline readers,"
                      "scrapers," etc., to access the Website for any purpose
                      without Fitfinity'sprior written approval.
                    </li>
                    <li>
                      You shall not in any manual or automated manner collect
                      Service Professionals or Service Users information,
                      including but not limited to, names, addresses, phone
                      numbers, or email addresses, copying copyrighted text, or
                      otherwise misuse or misappropriate Website information or
                      content, including but not limited to, use on a
                      "mirrored", competitive, or third party site.
                    </li>
                    <li>
                      You shall not in any way that transmits more request
                      messages to the Fitfinity servers, or any server of a Fitfinity
                      subsidiary or affiliate, in a given period of time than a
                      human can reasonably produce in the same period by using a
                      conventional online web browser; provided, however, that
                      the operators of public search engines may use spiders or
                      robots to copy materials from the site for the sole
                      purpose of creating publicly available searchable indices
                      of the materials, but not caches or archives of such
                      material. Fitfinity reserves the right to revoke these
                      exceptions either generally or in specific cases.
                    </li>
                    <li>
                      You shall not recruit, solicit, or contact in any form
                      Service Professionals or Service Users for employment or
                      contracting for a business not affiliated with Fitfinity
                      without express written permission from Fitfinity.
                    </li>
                    <li>
                      You shall not take any action that (i) unreasonably
                      encumbers or, in Fitfinity's sole discretion, may
                      unreasonably encumber the Website's infrastructure; (ii)
                      interferes or attempts to interfere with the proper
                      working of the Website or any third-party participation in
                      the Website; or (iii) bypasses Fitfinity's measures that are
                      used to prevent or restrict access to the Website.
                    </li>
                    <li>
                      You agree not to collect or harvest any personally
                      identifiable data, including without limitation, names or
                      other Account information, from the Website, nor to use
                      the communication systems provided by the Website for any
                      commercial solicitation purposes.
                    </li>
                  </ul>
                </div>
                <div className="feedback">
                  <strong> 5. ADDITIONAL POLICIES</strong>
                </div>
                <div className="feedback">
                  Your access to, use of, and participation in the Website is
                  subject to the Terms of Use and all applicable Fitfinity
                  regulations, guidelines and additional policies that Fitfinity
                  may set forth from time to time, including without limitation,
                  a copyright policy and any other restrictions or limitations
                  that Fitfinity publishes on the Website (the "Additional
                  Policies"). Fitfinity, in its sole discretion, may terminate your
                  Account at any time without prior notice to you as well as
                  initiate appropriate legal proceedings, if necessary.
                </div>
                <div className="feedback">
                  <strong>6. PROHIBITIONS ON SUBMITTED CONTENT </strong>
                </div>
                <div className="feedback">
                  <ul>
                    <li>
                      You shall not upload, post, transmit, transfer,
                      disseminate, distribute, or facilitate distribution of any
                      content, including text, images, video, sound, data,
                      information, or software, to any part of the Website,
                      including your profile ("Profile"), the posting of your
                      Service ("Offer"), the posting of your desired Service
                      ("Want"), or the posting of any opinions or reviews in
                      connection with the Website, the Service, the Service
                      Professional, or the Service User ("Feedback") (all of the
                      foregoing content is sometimes collectively referred to
                      herein as "Submitted Content" and the posting of Submitted
                      Content is sometimes referred to as a "Posting" or as
                      "Postings") that (1)contains falsehoods or
                      misrepresentations that could damage Fitfinity or any third
                      party, (2)misrepresents the source of anything you post,
                      including impersonation of another individual or entity or
                      any false or inaccurate biographical information for any
                      Service Professionals; provides or create links to
                      external sites that violate the Terms of Use; is intended
                      to harm or exploit any individual under the age of 18
                      ("Minor") in any way; is designed to solicit, or collect
                      personally identifiable information of any Minor,
                      including, but not limited to, name, email address, home
                      address, phone number, or the name of his or her school,
                      (3)invades anyone's privacy, (4) is pornographic,
                      harassing, hateful, illegal,obscene, defamatory, libelous,
                      slanderous, threatening, discriminatory, racially,
                      culturally or ethnically offensive; incites, advocates, or
                      expresses pornography, obscenity, vulgarity,profanity,
                      hatred, bigotry, racism, or gratuitous violence;
                      encourages conduct that would be considered a criminal
                      offense, (5) contains or promotes an illegal or
                      unauthorized copyof another person's copyrighted work, (6)
                      is copyrighted, protected by trade secret or otherwise
                      subject to third-party proprietary rights, (7) distributes
                      or contains viruses or any other technologies that may
                      harm Fitfinity, or the interests or property of Fitfinity users,
                      (8) is intended to threaten, stalk, defame, defraud,
                      degrade, victimize, or intimidate an individual or group
                      of individuals for any reason on the basis of age, gender,
                      disability,ethnicity, sexual orientation, race, or
                      religion; or to incite or encourage anyone else to do so.
                    </li>
                  </ul>
                </div>
                <div className="feedback">
                  <strong>7. PROHIBITIONS ON SENDING MESSAGES</strong>
                </div>
                <div className="feedback">
                  You will not send messages to other users containing (1)
                  unsolicited advertising or marketing of a service not offered
                  on the Website or an external website. (2)offers to make
                  national or international money transfers for amounts
                  exceeding the asking price of a service, with intent to
                  request a refund of any portion of the payment.
                </div>
                <div className="feedback">
                  <strong> 8. NO DISCRIMINATION</strong>
                </div>
                <div className="feedback">
                  Discriminatory Postings. Indian laws prohibit any preference,
                  limitation or discrimination based on race, color, religion,
                  sex, national origin, age, handicap or other protected class.
                  Bowootwill not knowingly accept any Posting which is in
                  violation of the law. Fitfinity has the right, in its sole
                  discretion and without prior notice to you; to immediately
                  remove any posting that discriminates or is any way in
                  violation of any law.
                </div>
                <div className="feedback">
                  <strong> 9. PROHIBITIONS WITH RESPECT TO SERVICES</strong>
                </div>
                <div className="feedback">
                  While using the Website, you shall not (1)if you violate any
                  laws, third-party rights, Account Policies, or any provision
                  of the Terms of Use, such as the prohibitions described above,
                  (2)post content or items in any inappropriate category or
                  areas on the Website, (3) if you fail to perform Services
                  purchased from you, unless the Service User fails to
                  materially meet the terms of the mutually agreed upon
                  agreement for the Services, refuses to pay, a clear
                  typographical error is made, or you cannot authenticate the
                  Service User's identity; manipulate the price of any
                  Service,(4)if you fail to deliver payment for Services
                  purchased by you, unless the Service Professional has
                  materially changed the description of the Service description
                  after you negotiate an agreement for such Service, a clear
                  typographical error is made, or you cannot authenticate the
                  Service Professional's identity (5) manipulate our fee
                  structure, the billing process, or fees owed to Fitfinity; post
                  false, inaccurate, misleading, defamatory, or libelous content
                  (including personalinformation about any Website user), (6)
                  take any action that may undermine the Feedback or ratings
                  systems
                </div>
                <div className="feedback">
                  <strong> 10. FEEDBACK</strong>
                </div>
                <div className="feedback">
                  As a participant in the Website, you agree to use careful,
                  prudent, and good judgment when leaving Feedback for another
                  user. The following actions constitute inappropriate uses of
                  Feedback: (a) threatening to leave negative or impartial
                  Feedback for another user unless that user provides services
                  not included in the original Posting or not agreed to as part
                  of the Service to be provided; (b) leaving Feedback in order
                  to make the Service Professional or Service User appear better
                  than he or she actually is or was; and (c) including
                  conditions in an Offer or Want that restrict a Service
                  Professional or a Service User from leaving Feedback. If you
                  violate any ofthe above-referenced rules in connection with
                  leaving Feedback, Fitfinity, in its sole discretion, may take any
                  of the following actions: (i) cancel your Feedback or any of
                  your Postings; (ii) limit your Account privileges; (iii)
                  suspend your Account; and/or (iv) decrease your status
                  earnedvia the Feedback page. You may contact Fitfinity regarding
                  any inappropriate use of Feedback via-email at
                  <a href="/support@Fitfinity"> support@Fitfinity.com.</a>
                </div>
                <div className="feedback">
                  IN THE EVENT OF ANY DISPUTE BETWEEN USERS OF THE WEBSITE
                  CONCERNING FEEDBACK, Fitfinity HAS THE RIGHT, IN ITS SOLE AND
                  ABSOLUTE DISCRETION, TO REMOVE SUCH FEEDBACK OR TAKE ANY
                  ACTION IT DEEMS REASONABLE WITHOUT INCURRING ANY LIABILITY
                  THEREFROM.
                </div>
                <div className="feedback">
                  <strong>
                    Fitfinity does not and cannot review every Posting posted to
                    the Website. These prohibitionsdo not require Fitfinity to
                    monitor, police or remove any Postings or other information
                    submitted by you or any other user.
                  </strong>
                </div>
                <div className="feedback">
                  <strong>Rules to be followed by Service Professionals</strong>
                </div>
                <div className="feedback">
                  <strong>
                    {" "}
                    11. PROFILES AND OFFERS MUST NOT BE FRAUDULENT
                  </strong>
                </div>
                <div className="feedback">
                  Subject to any exceptions set forth in these Terms of Use or
                  Additional Policies, if any, Service Professionals shall not:
                  (1) include any information in their Profile that is
                  fraudulent. (2) list Services or offers relating to any
                  Service in a category that is inappropriate to the Service
                  they are offering; (3) use misleading titles that do not
                  accurately describe the Service (4) misrepresent the location
                  at which they will provide a Service.
                </div>
                <div className="feedback">
                  <strong>
                    12. PROFILES AND OFFERS CANNOT USE TECHNIQUES TO AVOID OR
                    CIRCUMVENT Fitfinity FEES
                  </strong>
                </div>
                <div className="feedback">
                  Subject to any exceptions set forth in these Terms of Use or
                  Additional Policies, if any, Service Professionals shall not:
                  (a) offer a catalog or a link to a third-party website from
                  which Service Users or any Registered User or user of the
                  Website may obtain the Service directly; (b) exceed multiple
                  Posting limits; (c) post a single Service but offer additional
                  identical services in the Service description; (d) charge fees
                  for traveling further than desired to provide the Service; (e)
                  offer the opportunity through Fitfinity to purchase the Service
                  or any other service outside of Fitfinity; (f) use their Profile
                  page or user name to promote services not offered on or
                  through theWebsite and/or prohibited services. In case we
                  realize that any professional is involved in any of the above
                  activities, Fitfinity holds the sole discretion to blacklist the
                  professional and withhold any outstanding credits or payments
                  to the professional.
                </div>
                <div className="feedback">
                  <strong>
                    13. CONSENT FOR REACHING OUT VIA PHONE CALL, SMS, EMAIL OR
                    ANY OTHER FORM OF ELECTRONIC COMMUNICATION
                  </strong>
                </div>
                <div className="feedback">
                  It is further clarified that your registration on the Website
                  shall be deemed to be your consent to be contacted for the
                  purposes mentioned above, (i) on the mobile number shared by
                  you even if you are registered with the National Customer
                  Preference Register (NCPR) and have opted out of receiving
                  promotional calls and messages and (ii) by way of SMS or email
                  notifications or messages in any other electronic form
                </div>
                <div className="feedback">
                  <strong>
                    14. PRODUCTS UTILIZED WHILE RENDERING SERVICES TO THE
                    SERVICE USER(S)
                  </strong>
                </div>
                <div className="feedback">
                  The Service Professional will procure the Products from Fitfinity
                  only for rendering the Services facilitated through the
                  Fitfinity Platform. Any Product purchased by the Service
                  Professional from Fitfinity shall only be used for the sole
                  purpose of rendering services booked through Fitfinity Platform.
                  Products sold by Fitfinity to the Service Professional should not
                  be used for personal consumption by the Service Professional
                  under any circumstances. If a Service Professional violates
                  any of the above-referenced rules in connection with his or
                  her Posting, Fitfinity, in its sole discretion, may take any of
                  the following actions: (a) cancel the Posting; (b) limit the
                  Service Professional's Account privileges; (c) suspend the
                  Service Professional's Account; (d) cause the Service
                  Professional to forfeit any fees earned on a cancelled
                  Posting; and/or (e) decrease the Service Professional's status
                  earned via the Feedback page.
                </div>
                <div className="feedback">
                  <strong>
                    <h4>Rules to be followed by Service Users</h4>
                  </strong>
                </div>
                <div className="feedback">
                  <strong>
                    15. SERVICE USERS SHALL NOT TAKE ANY OF THE FOLLOWING
                    ACTIONS:
                  </strong>
                </div>
                <div className="feedback">
                  (a) commit to purchasing or using a Service without paying;
                  (b) sign up for, negotiate a price for,use, or otherwise
                  solicit a Service with no intention of following through with
                  your use of or payment for the Service; (c) agree to purchase
                  a Service when you do not meet the Service Professional's
                  terms as outlined in the Posting, or agree to purchase a
                  Service with the intention of disrupting a Posting; or (d)
                  misuse any options made available now or in the future by
                  Bowootin connection with the use or purchase of any Service.
                  If a Service Professional violates any of the above-referenced
                  rules in connection with his or her Posting, Fitfinity, in its
                  sole discretion, may take any of the following actions: (a)
                  cancel the Posting; (b) limit the Service Professional's
                  Account privileges; (c) suspend the Service Professional's
                  Account; (d) cause the Service Professional to forfeit any
                  fees earned on a cancelled Posting; and/or (e) decrease the
                  Service Professional's status earned via the Feedback page.
                </div>
                <div className="feedback">
                  <strong>
                    <h4>Use of Submitted Content16.</h4>
                  </strong>
                </div>
                <div className="feedback">
                  <strong>16.NO CONFIDENTIALITY</strong>
                </div>
                <div className="feedback">
                  The Website may now or in the future permit the submission of
                  videos or other communications submitted by you and other
                  users. You understand that whether or not such Submitted
                  Content is published, Fitfinity does not guarantee any
                  confidentiality with respect to any Submitted Content.You
                  agree that any Submitted Content provided by you for which you
                  authorize to be searchable by Registered Users who have access
                  to the Website is provided on a non-proprietary and
                  non-confidential basis. You agree that Fitfinity shall be free to
                  use or disseminate such freely searchable Submitted Content on
                  an unrestricted basis for the purpose of providing the
                  Services. You are aware that any information provided by you
                  in the Submitted Content towards locating aprofessional who
                  ordinarily is bound to maintain confidentiality under law with
                  his/her client (i.e. a doctor or a lawyer) is not extended to
                  Fitfinity.Fitfinity may also disclose user information including
                  personal information if Fitfinity reasonablybelieves that
                  disclosure (i) is necessary in order to comply with a legal
                  process (such as a court order, search warrant, etc.) or other
                  legal requirement of any governmental authority, (ii) would
                  potentially mitigate Fitfinity liability in an actual or
                  potential lawsuit, (iii) is otherwise necessary or appropriate
                  to protect our rights or property, or the rights or property
                  of any person or entity, (iv) to enforce this Agreement
                  (including, but not limited to ensuring payment of fees by
                  users), or (v) as may be required or necessary to deter
                  illegal behavior (including, but not limited to, fraud).
                </div>
                <div className="feedback">
                  <strong>17. YOUR REPRESENTATIONS AND WARRANTIES</strong>
                </div>
                <div className="feedback">
                  You shall be solely responsible for your own Submitted Content
                  and the consequences of postingor publishing it. You agree to
                  pay for all royalties, fees, and any other monies owing any
                  person by reason of any Submitted Content posted by you to or
                  through the Website.
                </div>
                <div className="feedback">
                  <strong>
                    18. YOUR OWNERSHIP RIGHTS AND LICENSE TO Fitfinity
                  </strong>
                </div>
                <div className="feedback">
                  You retain all of your ownership rights in your Submitted
                  Content. However, by submitting the Submitted Content to
                  Fitfinity for posting on the Website, you hereby grant, and you
                  represent and warrant that you have the right to grant, to
                  Fitfinity a perpetual, worldwide, non-exclusive, royalty-free,
                  sublicense able and transferable license to link to, use,
                  reproduce, distribute, reformat, translate, prepare derivative
                  works of, display, and perform the Submitted Content in
                  connection with the Website and Fitfinity's (and its successor's)
                  business operations, including without limitation, for the
                  promotion and redistribution of any part or all of the
                  Website, and any derivative works thereof, in any media
                  formats and through any media channels. You also herebygrant
                  each user of the Website a non-exclusive license to access
                  your Submitted Content through the Website, and to use,
                  reproduce, distribute, prepare derivative works of, display
                  and perform such Submitted Content as permitted through the
                  functionality of the Website and under these Terms of Use. The
                  foregoing license granted by you terminates once you remove or
                  delete the Submitted Content from the Website.You acknowledge
                  and understand that the technical processing and transmission
                  of the Website, including your Submitted Content, may involve
                  (a) transmissions over various networks; and (b) changes to
                  conform and adapt to technical requirements of connecting
                  networks or devices.You may remove your Submitted Content from
                  the Website at any time. If you choose to remove your
                  Submitted Content, the license granted above will
                  automatically expire.
                </div>
                <div className="feedback">
                  <strong>19. Fitfinity'S DISCLAIMERS AND RIGHT TO REMOVE</strong>
                </div>
                <div>
                  Fitfinity does not endorse any Submitted Content or any opinion,
                  recommendation, or advice expressed therein, and Fitfinity
                  expressly disclaims any and all liability in connection with
                  all Submitted Content. Fitfinity does not permit copyright
                  infringing activities and infringement of intellectual
                  property rights on the Website, and Fitfinity will remove any
                  Data (as defined below) or Submitted Content if properly
                  notified, pursuant to the "take down" notification procedure
                  described in Section J below, that such Posting or Submitted
                  Content infringes on another's intellectual property rights.
                  Fitfinity reserves the right to remove any Data or Submitted
                  Content without prior notice. Fitfinity will also terminate a
                  user's access to the Website, if he or she is determined to be
                  a repeat infringer. A repeat infringer is a Website user who
                  has been notified of infringing activity more than twice and/
                  or has had Submitted Content removed from the Websitemore than
                  twice. Fitfinity also reserves the right, in its sole and
                  absolute discretion, to decide whether any Data or Submitted
                  Content is appropriate and complies with these Terms of Use
                  for all violations, in addition to copyright infringement and
                  violations of intellectual property law, including, but not
                  limited to, pornography, obscene or defamatory material, or
                  excessive length. Fitfinity may remove such Submitted Content
                  and/or terminate a user's access for uploading suchmaterial in
                  violation of these Terms of Use at any time, without prior
                  notice and in its sole discretion. You are solely responsible
                  for the photos, profiles and other content, including, without
                  limitation, Submitted Content that you publish or display on
                  or through the Website, or transmit to other Website users.
                  You understand and agree that Fitfinity may, in its sole
                  discretionand without incurring any liability, review and
                  delete or remove any Submitted Content that violates this
                  Agreement or which might be offensive, illegal, or that might
                  violate the rights, harm, or threaten the safety of Website
                  users or others. You acknowledge and understand that when
                  using the Website, you will be exposed to Submitted Content
                  from a variety of sources, and that Fitfinity is not responsible
                  for the accuracy, usefulness, safety, or intellectual property
                  rights of or relating to such Submitted Content. You further
                  acknowledge and understand that you may be exposed to
                  Submitted Content that is inaccurate, offensive, indecent, or
                  objectionable, and you agree to waive, and hereby do waive,
                  any legal or equitable rights or remedies you have or may have
                  against Fitfinity with respect thereto, and agree to indemnify
                  andhold Fitfinity, its owners, members, managers, operators,
                  directors, officers, agents, affiliates, and/or licensors,
                  harmless to the fullest extent allowed by law regarding all
                  matters related to your use of the Website.
                </div>
                <div className="feedback">
                  <strong>20. SUGGESTIONS</strong>
                </div>
                <div className="feedback">
                  If you send or transmit any communications, comments,
                  questions, suggestions, or related materials to Fitfinity,
                  whether by letter, email, telephone, or otherwise
                  (collectively, "Suggestions"), suggesting or recommending
                  changes to the Website, including, without limitation, new
                  features or functionality relating thereto, all such
                  Suggestions are, and will be treated as, non-confidential and
                  non-proprietary. You hereby assign all right, title, and
                  interest in, and Fitfinity is free to use, without any
                  attribution or compensation to you, any ideas, know-how,
                  concepts, techniques, or other intellectual property and
                  proprietary rights contained in the Suggestions, whether or
                  not patentable, for any purpose whatsoever, including but not
                  limited to,developing, manufacturing, having manufactured,
                  licensing, marketing, and selling, directly or indirectly,
                  products and services using such Suggestions. You understand
                  and agree that Fitfinity is not obligated to use, display,
                  reproduce, or distribute any such ideas, know-how, concepts,
                  or techniques contained in the Suggestions, and you have no
                  right to compel such use, display, reproduction, or
                  distribution or seek recognition if the Suggestions are in
                  fact implemented.
                </div>

                <div className="feedback">
                  <strong>
                    <ul>
                      <li>Copyright Infringement</li>
                    </ul>
                  </strong>
                </div>
                <div className="feedback">
                  Fitfinity has high regard for intellectual property and expects
                  the same level of standard to be employed by its users. Fitfinity
                  may, in appropriate circumstances and at its discretion,
                  terminate the Account or prohibit access to the Website of
                  users who infringe upon the intellectual propertyrights of
                  others.If you believe that your work has been copied and
                  posted on the Website in a way that constitutescopyright
                  infringement and/or trademark infringement, please send the
                  following information to us at <a href="">help@Fitfinity.com</a>
                  (a) identification of the copyrighted and/or trademarked work
                  claimed to have been infringed, or, if multiple works at a
                  single online site are covered by a single notification, a
                  representative list of such works at that site; (b) a written
                  statement that you have agood faith belief that the disputed
                  use is not authorized by the copyright and/or trademark
                  owner,its agent, or the law;(c) identification of the material
                  that is claimed to be infringing or to be the subject of
                  infringing activity and that is to be removed or access to
                  which is to be disabled at the Website, and information
                  reasonably sufficient to permit Fitfinity to locate the material.
                  (d) an electronic or physical signature of the person
                  authorized to act on behalf of the owner of an exclusive
                  interest that is allegedly infringed; and (e) information
                  reasonably sufficient to permit Fitfinity to contact you as the
                  complaining party, such as an address, telephone number, and,
                  if available, an electronic mail address at which you may be
                  contacted; (f) a statement by you, made under penalty of
                  perjury, that the information in your report is accurate and
                  that you are theowner of the exclusive right or authorized to
                  act on the behalf of the owner of the exclusive right.A
                  statement by you comprised of the foregoing points is referred
                  to herein as the "Notice."Only the intellectual property
                  rights owner is permitted to report potentially infringing
                  items through Fitfinity's reporting system set forth above. If
                  you are not the intellectual property rights owner, you should
                  contact the intellectual property rights owner and they can
                  choose whether to use the procedures set forth in these Terms
                  of Use.
                </div>
                <div className="feedback">
                  <strong>
                    <h4>Modifications to or Termination of Website</h4>
                  </strong>
                </div>
                <div className="feedback">
                  Fitfinity reserves the right at any time and from time to time to
                  modify or discontinue, temporarily or permanently, the Website
                  (or any part thereof) with or without notice and in its sole
                  discretion. You agree that Fitfinity shall not be liable to you
                  or to any third party for any modification, suspension or
                  discontinuance of Fitfinity services. You hereby acknowledge and
                  agree that Fitfinity, in its sole and absolute discretion, has
                  the right (but not the obligation) to delete, terminate, or
                  deactivate your Account, block your email or IP address,
                  cancel the Website or otherwise terminate your access to or
                  participation in the use of the Website (or any part thereof),
                  or remove and discard any Submitted Content on the Website
                  ("Termination of Service"), immediately and without notice,
                  for any reason, including without limitation, Account
                  inactivity or if Fitfinity believes or has reason to believe that
                  you have violated any provision of the Terms of Use.You may
                  cancel your use of the Website and/or terminate the Terms of
                  Use with or without cause at any time by following the link in
                  your Account under "Account Preferences" to "Deactivate
                  Account." Unless Fitfinity has previously cancelled or terminated
                  your use of the Website (in which case subsequent notice by
                  Fitfinity shall not be required), if you provided a valid email
                  address during registration, Fitfinity will notify you via email
                  of any such termination or cancellation, which shall be
                  effective immediately upon Fitfinity's delivery ofsuch notice.
                  You agree to indemnify and hold Fitfinity, and its officers,
                  managers, members, affiliates, successor, assigns, directors,
                  agents, service professionals, suppliers, and employees
                  harmless from any claim or demand, including reasonable
                  attorneys' fees and court costs, made by any third party due
                  to or arising out of the Termination of Service.
                </div>
                <div className="feedback">
                  <strong>
                    <h4>Intellectual Property Rights</h4>
                  </strong>
                </div>
                <div className="feedback">
                  <strong>
                    <h4>
                      Fitfinity OWNS OR HOLDS THE LICENSES TO ALL DATA AND MARKS ON
                      THE WEBSITE
                    </h4>
                  </strong>
                </div>
                <div className="feedback">
                  The content on the Website (exclusive of all Submitted
                  Content), including without limitation, the text, software,
                  scripts, graphics, photos, sounds, music, videos, interactive
                  features and the like ("Data") and the trademarks, service
                  marks and logos contained therein ("Marks"), are owned by
                  Fitfinity. Other trademarks, names and logos on this Website are
                  the property of their respective owners.
                </div>
                <div className="feedback">
                  <strong>
                    21. Fitfinity'S LICENSE TO YOU FOR THE USE OF DATA AND MARKS
                  </strong>
                </div>
                <div className="feedback">
                  The Website contains Fitfinity's Data and Marks, which are, or
                  may become, protected by copyright, trademark, patent, trade
                  secret and other laws, and Fitfinity owns and retains all rights
                  in the Fitfinity Data and Marks. Subject to these Terms of Use,
                  Fitfinity hereby grants you a limited, revocable,
                  nontransferable, nonsublicensable license to reproduce and
                  display the Fitfinity Data (excluding any software source code)
                  solely for your personal use in connection with accessing and
                  participating in the Website. The Website may also contain
                  Data of other users or licensors, which you shall not copy,
                  modify,translate, publish, broadcast, transmit, distribute,
                  perform, display, or sell.
                </div>
                <div className="feedback">
                  <strong>22. FEES INCURRED BY SERVICE PROFESSIONALS</strong>
                </div>
                <div className="feedback">
                  Joining Fitfinity, opening an Account, posting Services and
                  viewing posted Services is free. Fitfinity reserves the right at
                  its sole discretion to charge fees to Service Professionals
                  for other services that Fitfinity may provide in the future.
                  Fitfinity may also in certain categories require Service
                  Professionals to make payments for following up on job leads
                  i.e. requests posted by Service Users, and permitting the
                  Service Professional to contact the Service User (“Lead Fee”)
                  irrespective of whether the job leads eventually result in a
                  transaction or exchange of consideration for the service
                  requested. In order to be eligible to make such Lead Fee
                  payment, Service Professionals shall be required to make
                  advance payments (“Credits”) from which the Lead Fee may be
                  deducted as and when necessary. Whenever the Credits fall
                  below the prescribed threshold, the Service Professional shall
                  be prompted to refill the Credits in order to continue
                  enjoying the ability to follow up on leads and contacting
                  Service Users.
                </div>
                <div className="feedback">
                  The service professional is entitled to refund of credits that
                  is credited back in their wallet in the following conditions:
                </div>
                <div>
                  <ol>
                    <li>
                      Refunds are processed when customer cancels request{" "}
                    </li>
                    <li>
                      Refunds are processed if the customer has not viewed quote
                      and not cancelled request 4 days after your response
                    </li>
                  </ol>
                </div>
                <div className="feedback">
                  In the event, (i) the job lead is identified to be
                  non-genuine, or (ii) the Service User within 48 hours of
                  posting a request on the Website withdraws the same by way of
                  the Website or the mobile application only, or (iii) the
                  Service Professional pays the Lead Fee to respond to the
                  Service User’s request for service but the Service User does
                  not open or access the Service Professional’s response, the
                  Lead Fee shall be reimbursed to the Service Professional. The
                  decision of Fitfinity pertaining to the above shall be final and
                  binding.Fitfinity offers premium services to Service
                  Professionals for a fee and may in the future offer additional
                  services, like tax preparation and bookkeeping that Service
                  Professionals can also choose to purchase. Fitfinity reserves the
                  right to charge fees for these services at its sole
                  discretion.
                </div>
                <div className="feedback">
                  <strong> 23. FEES INCURRED BY SERVICE USERS</strong>
                </div>
                <div className="feedback">
                  Joining Fitfinity, opening an Account, viewing posted Services,
                  and bidding on posted Services isfree. Fitfinity currently does
                  not charge Service Users for transactions completed on the
                  Website between Service Users and Services Professionals.
                  However, Fitfinity reserves the right to chargea fee to Service
                  Users in the future on a per-transaction basis or in any other
                  manner, and reserves the right to do so in its sole
                  discretion. Changes to this Fee Policy are effective after
                  Fitfinity has provided you with thirty (30) days' notice by
                  posting the changes on the Website. If applicable, you agree
                  to pay all fees or charges to your Account based on Fitfinity's
                  fees, charges, and billing terms then in effect. If you do not
                  pay on time or if Fitfinity cannot charge your credit card, any
                  payment gateway or other payment method for any reason, Fitfinity
                  reserves the right to either suspend or terminate your access
                  to the Website and Account and terminate these Terms of Use.
                  You are expressly agreeing that Fitfinity is permitted to bill
                  you forthe applicable fees, any applicable tax and any other
                  charges you may incur in connection with your use of this
                  Website and the fees will be billed to your credit card, a
                  payment gateway or other payment method designated at the time
                  you make a purchase or register for a fee-based service. If
                  you cancel your Account at any time, you will not receive any
                  refund. If you have a balance due on any account, you agree
                  that Fitfinity may charge such unpaid fees to your credit card or
                  otherwise bill you for such unpaid fees. Fitfinity reserves its
                  right to initiate appropriate legal proceedings, if necessary,
                  in its sole discretion, to recover such outstanding amounts.
                </div>
                <div className="feedback">
                  <strong>24. REFUND POLICY</strong>
                </div>
                <div className="feedback">
                  All commissions payable to Fitfinity by Service Professionals on
                  consummated transactions, i.e. exchange of services for
                  consideration, are final and non-refundable.The nominal amount
                  paid while booking the trial session will be adjusted with the
                  service package payment only when you go ahead with the
                  service package and make payment for the same. By paying this
                  nominal amount you are only assuring us that you are a genuine
                  and valuable customer for us.All monies paid by Service
                  Professionals in form of “Credits” are non-interest bearing.
                  Unutilized and unclaimed "Credits" for a period of more than
                  364 days from the date of purchaseof "Credits" shall expire
                  and stand forfeited. No refunds of credits will be processed
                  after the expiry date.
                </div>
                <div className="feedback">
                  <strong>25. TAXES</strong>
                </div>
                <div className="feedback">
                  You understand that we are acting solely as an intermediary
                  for the collection of rents and fees between a Service User
                  and a Service Professional who choose to enter into an
                  Agreement for Service. Because state and local tax laws vary
                  significantly by locality, you understand and agreethat you
                  are solely responsible for determining your own tax reporting
                  requirements in consultation with tax advisors, and that we
                  cannot and do not offer tax advice to either hosts or guests.
                  Further, you understand that Fitfinity shall not be responsible
                  or liable in any manner in relation to tax liability of a
                  Service User or a Service Professional.
                </div>
                <div className="feedback">
                  <strong>
                    26. Fitfinity IS NOT A PARTY TO ANY SERVICE CONTRACT
                  </strong>
                </div>
                <div className="feedback">
                  Each Registered User hereby acknowledges and agrees that
                  Fitfinity is NOT a party to any oral or written Agreement for
                  Service, Negotiation Worksheet, or any contract entered into
                  between Registered Users in connection with any Service
                  offered, directly or indirectly, through the Website. Each
                  Registered User acknowledges, agrees and understands that
                  Fitfinity only seeks to provide a platform wherein the Service
                  User and Service Professional can be brought together and
                  Fitfinity itself has not role in the execution or provision of
                  Services.
                </div>
                <div className="feedback">
                  <strong> 27. NO AGENCY, PARTNERSHIP OR JOINT VENTURE</strong>
                </div>
                <div className="feedback">
                  No agency, partnership, joint venture, or employment is
                  created as a result of the Terms of Use oryour use of any part
                  of the Website, including without limitation, the Negotiation
                  Worksheet or Agreement for Service. You do not have any
                  authority whatsoever to bind Fitfinity in any respect.All Service
                  Professionals are independent contractors. Neither Fitfinity nor
                  any users of the Website may direct or control the day-to-day
                  activities of the other, or create or assume any obligation on
                  behalf of the other.
                </div>
                <div className="feedback">
                  <strong>
                    <h4>DISPUTES BETWEEN REGISTERED USERS</h4>
                  </strong>
                </div>
                <div className="feedback">
                  Subject to the provisions regarding disputes between Website
                  participants in connection with Feedback, your interactions
                  with individuals and/or organizations found on or through the
                  Website, including payment of and performance of any Service,
                  and any other terms, conditions, warranties or representations
                  associated with such transactions or dealings, are solely
                  between you and such individual or organization. You should
                  take reasonable precautions and make whatever investigation or
                  inquiries you deem necessary or appropriate before proceeding
                  with any online or offline transaction with any third party,
                  including without limitation, service professionals and
                  Service Users, keep in mind the fact that Fitfinity only seeks to
                  provide a platform wherein Service Users and Service
                  Professionals have an opportunity to meet each other.
                </div>
                <div className="feedback">
                  NOTWITHSTANDING THE FOREGOING, YOU AGREE THAT SINCE Fitfinity
                  only seeks to provide a platform wherein the Service User and
                  Service Professional can be brought together and Fitfinity itself
                  has not role in the execution or provision of Services ITSELF,
                  Fitfinity SHALL NOT BE RESPONSIBLE OR LIABLE FOR ANY LOSS OR
                  DAMAGE OFANY SORT WHATSOEVER INCURRED AS THE RESULT OF ANY
                  SUCH TRANSACTIONOR DEALINGS. IF THERE IS A DISPUTE BETWEEN
                  PARTICIPANTS ON THE WEBSITE, OR BETWEEN REGISTERED USERS OR
                  ANY WEBSITE USER AND ANY THIRD PARTY,YOU ACKNOWLEDGE AND AGREE
                  THAT Fitfinity IS UNDER NO OBLIGATION TO BECOME INVOLVED. IN THE
                  EVENT THAT A DISPUTE ARISES BETWEEN YOU AND ONE OR MORE
                  WEBSITE USERS, REGISTERED USERS OR ANY THIRD PARTY, YOU HEREBY
                  RELEASE Fitfinity, ITS OFFICERS, MANAGERS, MEMBERS, DIRECTORS,
                  EMPLOYEES, ATTORNEYS, AGENTS, AND SUCCESSORS IN RIGHTS FROM
                  ANY CLAIMS, DEMANDS, AND DAMAGES (ACTUAL AND CONSEQUENTIAL) OF
                  EVERY KIND OR NATURE, KNOWN OR UNKNOWN, SUSPECTED OR
                  UNSUSPECTED, FORESEEABLE OR UNFORESEEABLE, DISCLOSED OR
                  UNDISCLOSED, ARISING OUTOF OR IN ANY WAY RELATED TO SUCH
                  DISPUTES AND/OR THE WEBSITE OR ANY SERVICE PROVIDED
                  THEREUNDER.
                </div>
                <div className="feedback">
                  <strong>
                    <h4>Dispute Resolution</h4>
                  </strong>
                </div>
                <div className="feedback">
                  If a dispute arises between you and Fitfinity, our goal is to
                  provide you with a neutral and cost effective means of
                  resolving the dispute quickly. Accordingly, you and Fitfinity
                  hereby agree thatwe will resolve any claim or controversy at
                  law and equity that arises out of the Terms of Use or the
                  Website, Before resorting to the filing of a formal lawsuit,
                  we strongly encourage you to first contact us directly to seek
                  a resolution via e-mail at support@Fitfinity.com. The dispute
                  shall be resolved through alternative dispute resolution
                  procedures, such as mediation or arbitration, as alternatives
                  to litigation.
                </div>
                <div className="feedback">
                  The Terms of Use shall be governed in all respects by the laws
                  of India and any legal proceeding arising out of this
                  Agreement will occur exclusively in the courts located in
                  Bangalore, India.
                </div>
                <div className="feedback">
                  Aspects of the Website and other Fitfinity services may be
                  supported by advertising revenue. As such, Fitfinity may display
                  advertisements and promotions on the service.
                </div>
                <div className="feedback">
                  The Website may provide, or third parties may provide, links,
                  contact forms and/or phone numbers to other websites or
                  resources, including, without limitation, social networking,
                  blogging and similar websites through which you are able to
                  log into the Website using your existing account and log-in
                  credentials for such third-party websites. Your dealings and
                  communications through the Website with any party other than
                  Fitfinity are solely between you and such third party. Any
                  complaints, concerns or questions you have relating to
                  materials provided by third parties should be forwarded
                  directly to the applicable third party.
                </div>
                <div className="feedback">
                  <strong>Limitations of Liability</strong>
                </div>
                <div className="feedback">
                  1. IN NO EVENT SHALL Fitfinity, OR ITS RESPECTIVE OFFICERS,
                  MANAGERS, MEMBERS, DIRECTORS, EMPLOYEES, SUCCESSORS, ASSIGNS,
                  SUBSIDIARIES, AFFILIATES, SERVICE PROFESSIONALS, SUPPLIERS,
                  ATTORNEYS OR AGENTS, BE LIABLE TO YOU FOR ANY DIRECT,
                  INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, CONSEQUENTIAL OR
                  EXEMPLARY DAMAGES (INCLUDING BUT NOT LIMITED TO LOSS OF
                  BUSINESS, REVENUE, PROFITS, USE, DATA OR OTHER ECONOMIC
                  ADVANTAGE) WHATSOEVER RESULTING FROM ANY (I) ACCESS TO OR USE
                  OF THEWEBSITE OR ANY SERVICES OFFERED BY ANY SERVICE
                  PROFESSIONALS VIA THE WEBSITE, INCLUDING SERVICES PROVIDED
                  PURSUANT TO AN AGREEMENT FORMED INDEPENDENTLY OF THE WEBSITE,
                  WHETHER OR NOT AN AGREEMENT FOR SERVICE FORMED VIA THE WEBSITE
                  IS IN EFFECT; (II) ERRORS, MISTAKES, ORINACCURACIES OF DATA,
                  MARKS, CONTENT, INFORMATION, MATERIALS OR SUBSTANCE OF THE
                  WEBSITE OR SUBMITTED CONTENT; (III) ANY UNAUTHORIZED ACCESS TO
                  OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL
                  INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN; (IV)
                  ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE
                  TRANSMITTED TO OR THROUGH THE WEBSITE BY ANY THIRD PARTY; (V)
                  ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE
                  WEBSITE; (VI)ANY ERRORS OR OMISSIONS IN ANY DATA, CONTENT,
                  INFORMATION, MATERIALS OR SUBSTANCE OF THE WEBSITE OR
                  SUBMITTED CONTENT; (VII) ANY FAILED NEGOTIATIONS FOR A
                  SERVICE, ANY DISPUTES THAT ARISE DURING OR AFTER THE
                  NEGOTIATION OF A SERVICE OR THE FORMATION OF A CONTRACT FOR A
                  SERVICE, OR ANY OTHER DISPUTE THAT ARISES BETWEEN USERS OF THE
                  WEBSITE; (VIII) ANY DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT
                  OF ANY THIRD PARTY OR SERVICE USER OR SERVICE PROFESSIONAL; OR
                  (IX) ANY USE OF ANY DATA, MARKS, CONTENT, INFORMATION,
                  MATERIALS OR SUBSTANCE OF THE WEBSITE OR SUBMITTED CONTENT
                  POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE ON
                  OR THROUGH THE WEBSITE, WHETHER BASED ON WARRANTY, CONTRACT,
                  TORT (INCLUDING NEGLIGENCE), OR ANY OTHER LEGAL THEORY, AND
                  WHETHER OR NOT Fitfinity IS ADVISED OF THE POSSIBILITY OF SUCH
                  DAMAGES. THE FOREGOING LIMITATION OF LIABILITY SHALL APPLY TO
                  THE FULLEST EXTENT PERMITTED BY LAW IN THE APPLICABLE
                  JURISDICTION.
                </div>
                <div className="feedback">
                  2. IN NO EVENT SHALL THE TOTAL, AGGREGATE LIABILITY OF Fitfinity,
                  OR ANY OF THE ABOVE-REFERENCED RESPECTIVE PARTIES, ARISING
                  FROM OR RELATING TO THE WEBSITE, AND/OR SUBMITTED CONTENT
                  EXCEED THE TOTAL AMOUNT OF FEES ACTUALLY PAID TO Fitfinity BY YOU
                  HEREUNDER.YOU HEREBY ACKNOWLEDGE AND AGREE THAT Fitfinity SHALL
                  NOT BE LIABLE FOR SUBMITTED CONTENT OR THE DEFAMATORY,
                  OFFENSIVE, OR ILLEGAL CONDUCT OF ANY THIRD PARTY OR SERVICE
                  USER OR SERVICE PROVIDER AND THAT THE RISK OF HARM OR DAMAGE
                  FROM THE FOREGOING RESTS ENTIRELY WITH YOU. YOU FURTHER
                  ACKNOWLEDGE AND AGREE THAT Fitfinity SHALL NOT BE LIABLE FOR ANY
                  DIRECT, INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, CONSEQUENTIAL
                  OR EXEMPLARY DAMAGES (INCLUDING BUT NOT LIMITED TO LOSS OF
                  BUSINESS, REVENUE, PROFITS, USE, DATA OR OTHER ECONOMIC
                  ADVANTAGE) WHATSOEVER RESULTING FROM OR RELATING TO ANY
                  CONTRACT BETWEEN WEBSITE USERS ENTERED INTO INDEPENDENTLY OF
                  THE WEBSITE.THE WEBSITE MAY CONTAIN LINKS TO THIRD-PARTY
                  WEBSITES THAT ARE NOT OWNED OR CONTROLLED BY Fitfinity. Fitfinity
                  DOES NOT HAVE ANY CONTROL OVER, AND ASSUMES NO RESPONSIBILITY
                  FOR, THE CONTENT, PRIVACY POLICIES, OR PRACTICES OF ANY
                  THIRD-PARTY WEBSITES. IN ADDITION, Fitfinity WILL NOT AND CANNOT
                  CENSOR OR EDIT THE CONTENT OF ANY THIRD-PARTY SITE. BY USING
                  THE WEBSITE, YOU EXPRESSLY RELIEVE Fitfinity FROM ANY AND ALL
                  LIABILITY ARISING FROM YOUR USE OF ANY THIRDPARTY WEBSITE.
                  ACCORDINGLY, PLEASE BE ADVISED TO READ THE TERMS AND
                  CONDITIONS AND PRIVACY POLICY OF EACH THIRD-PARTY WEBSITE THAT
                  YOU VISIT, INCLUDING THOSE DIRECTED BY THE LINKS CONTAINED ON
                  THE WEBSITE.
                </div>
                <div className="feedback">
                  <strong>Disclaimer of Warranties</strong>
                </div>
                <div className="feedback">
                  YOU AGREE THAT YOUR USE OF THE WEBSITE SHALL BE AT YOUR OWN
                  RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, AND Fitfinity AND
                  ITS OFFICERS, MANAGERS, MEMBERS, DIRECTORS, EMPLOYEES,
                  SUCCESSORS, ASSIGNS, SUBSIDIARIES, AFFILIATES, SERVICE
                  PROFESSIONALS, SUPPLIERS, AND AGENTS DISCLAIM ALL WARRANTIES,
                  EXPRESS, IMPLIED, STATUTORY OR OTHERWISE, AND MAKE NO
                  WARRANTIES, REPRESENTATIONS, OR GUARANTEES IN CONNECTION WITH
                  THIS WEBSITE, THE SERVICES OFFERED ON OR THROUGH THIS WEBSITE,
                  ANY DATA, MATERIALS, SUBMITTED CONTENT, RELATING TO THE
                  QUALITY, SUITABILITY, TRUTH, ACCURACY OR COMPLETENESS OF ANY
                  INFORMATION OR MATERIAL CONTAINED OR PRESENTED ON THIS
                  WEBSITE, INCLUDING WITHOUT LIMITATION THE MATERIALS, DATA AND
                  SUBMITTED CONTENT OF OTHER USERS OF THIS SITE OR OTHER THIRD
                  PARTIES. UNLESS OTHERWISE EXPLICITLY STATED, TO THE MAXIMUM
                  EXTENT PERMITTED BY APPLICABLE LAW, THIS WEBSITE, THE SERVICES
                  OFFERED ON OR THROUGH THIS WEBSITE, DATA, MATERIALS, SUBMITTED
                  CONTENT, AND ANY INFORMATION OR MATERIAL CONTAINED OR
                  PRESENTED ON THIS WEBSITE IS PROVIDED TO YOU ON AN "AS IS,"
                  "AS AVAILABLE" AND "WHEREIS" BASIS WITH NO WARRANTY OF IMPLIED
                  WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                  OR NON-INFRINGEMENT OF THIRD-PARTY RIGHTS. Fitfinity DOES NOT
                  PROVIDE ANY WARRANTIES AGAINST ERRORS, MISTAKES, OR
                  INACCURACIES OF DATA, CONTENT, INFORMATION, MATERIALS,
                  SUBSTANCE OF THE WEBSITE OR SUBMITTED CONTENT, ANY
                  UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY
                  AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION
                  STORED THEREIN, ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE
                  WHICH MAY BE TRANSMITTED TO OR THROUGH THE WEBSITE BY ANY
                  THIRD PARTY, ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO
                  OR FROM THE WEBSITE, ANY DEFAMATORY, OFFENSIVE, OR ILLEGAL
                  CONDUCT OF ANY THIRD PARTY OR SERVICE USER OR SERVICE
                  PROVIDER, OR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A
                  RESULT OF THE USE OF ANY DATA, CONTENT, INFORMATION,
                  MATERIALS, SUBSTANCE OF THE WEBSITE OR SUBMITTED CONTENT
                  POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA
                  THE WEBSITE. Fitfinity DOES NOT ENDORSE, WARRANT, GUARANTEE, OR
                  ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR
                  OFFERED BY A THIRD PARTY THROUGH THE WEBSITE OR ANY
                  HYPERLINKED SITE OR FEATURED IN ANY BANNER OR OTHER
                  ADVERTISEMENT. Fitfinity WILL NOT BE A PARTY TO OR IN ANY WAY BE
                  RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY
                  PARTY, INCLUDING THIRD PARTY SERVICE PROFESSIONALS OF PRODUCTS
                  OR SERVICES. AS WITH THE USE OF ANY PRODUCT OR SERVICE, AND
                  THE PUBLISHING OR POSTING OF ANY MATERIAL THROUGH ANY MEDIUM
                  OR IN ANY ENVIRONMENT, YOU SHOULDUSE YOUR BEST JUDGMENT AND
                  EXERCISE CAUTION WHERE APPROPRIATE.
                </div>
                <div className="feedback">
                  <strong>In case of Natural disasters</strong>
                </div>
                <div className="feedback">
                  Neither Fitfinity nor you shall be liable to the other for any
                  delay or failure in performance under the Terms of Use, other
                  than payment obligations, arising out of a cause beyond its
                  control and without its fault or negligence. Such causes may
                  include, but are not limited to fires, floods, earthquakes,
                  strikes, unavailability of necessary utilities, blackouts,
                  acts of God, acts of declared or undeclared war, acts of
                  regulatory agencies, or national disasters.
                </div>
                <div>
                  <strong>Indemnification and Release </strong>
                </div>
                <div className="feedback">
                  YOU AGREE TO DEFEND, INDEMNIFY AND HOLD HARMLESS Fitfinity, AND
                  ITS OFFICERS, MANAGERS, MEMBERS, DIRECTORS, EMPLOYEES,
                  SUCCESSORS, ASSIGNS, SUBSIDIARIES, AFFILIATES, SERVICE
                  PROFESSIONALS, SUPPLIERS, AND AGENTS, FROM AND AGAINST ANY AND
                  ALL CLAIMS, DAMAGES, OBLIGATIONS, LOSSES, LIABILITIES, COSTS
                  OR DEBT, AND EXPENSES (INCLUDING BUT NOT LIMITED TO ATTORNEYS'
                  FEES) ARISING FROM YOUR USE OF, ACCESS TO, AND PARTICIPATION
                  IN THE WEBSITE; YOUR VIOLATION OF ANY PROVISION OF THE TERMS
                  OF USE, INCLUDING THE PRIVACY POLICY; YOUR VIOLATION OF ANY
                  THIRD-PARTY RIGHT, INCLUDING WITHOUT LIMITATION ANY COPYRIGHT,
                  PROPERTY, PROPRIETARY, INTELLECTUAL PROPERTY, OR PRIVACY
                  RIGHT; OR ANYCLAIM THAT YOUR SUBMITTED CONTENT CAUSED DAMAGE
                  TO A THIRD PARTY. THIS DEFENSE AND INDEMNIFICATION OBLIGATION
                  WILL SURVIVE THESE TERMSOF SERVICE AND YOUR USE OF THE
                  WEBSITE.IF YOU HAVE A DISPUTE WITH ONE OR MORE WEBSITE USERS,
                  YOU FOREVER RELEASE Fitfinity (AND ITS OFFICERS, MANAGERS,
                  MEMBERS, DIRECTORS, EMPLOYEES, SUCCESSORS, ASSIGNS,
                  SUBSIDIARIES, AFFILIATES, SERVICE PROFESSIONALS, SUPPLIERS,
                  AGENTS, SUBSIDIARIES, AND EMPLOYEES) FROM ANY AND ALL CLAIMS,
                  DEMANDS AND DAMAGES (ACTUAL AND CONSEQUENTIAL) OF EVERY KIND
                  AND NATURE, KNOWN AND UNKNOWN, ARISING OUT OF OR IN ANY WAY
                  CONNECTED WITH YOUR USE OF THE WEBSITE AND/OR ANY SUBMITTED
                  CONTENT.THE TERMS OF USE, AND ANY RIGHTS AND LICENSES GRANTED
                  HEREUNDER, MAY NOT BE TRANSFERRED OR ASSIGNED BY YOU, BUT MAY
                  BE ASSIGNED BY Fitfinity WITHOUT RESTRICTION.
                </div>
                <div className="feedback">
                  <strong>
                    <ul>
                      <li>No Third-party</li>
                    </ul>
                  </strong>
                </div>
                <div className="feedback">
                  Beneficiaries You agree that, except as otherwise expressly
                  provided in the Terms of Use, there shall be no third-party
                  beneficiaries to the Terms of Use.
                </div>
                <div className="feedback">
                  <strong>
                    <ul>
                      <li>Notice</li>
                    </ul>
                  </strong>
                </div>
                <div className="feedback">
                  You agree that Fitfinity may provide you with notices, including
                  those regarding changes to the Terms of Use, by email, regular
                  mail, or postings on the Website.
                </div>
                <div>
                  <strong>
                    Fitfinity India Technology Private Limited. All Rights Reserved
                  </strong>
                </div>
              </div>
              <div className="col-sm-2"></div>
            </div>
          </div>
        </div>
        <br />
        <Footer />
      </>
    );
  }
}

export default TermsConditions;
